<template>
  <div
    :id="`#expanding-content-${namespace}`"
    class="expanding-content"
    :class="{
      [$class('minimised')]: !isExpanded && expandable,
    }"
  >
    <div v-if="!isExpanded">
      <span
        aria-hidden="true"
        class="expanding-content__excerpt mr-s"
        v-html="textContent.slice(0, characterLimit)"
      />

      <btn
        v-if="expandable"
        class="expanding-content__button"
        class-label="text-body-s-regular"
        :icon="IconArrowDown"
        :label="$string('accessibility.expand')"
        show-icon
        modifiers="reset"
        :aria-expanded="isExpanded"
        :aria-controls="`#expanding-content-${namespace}`"
        @click="isExpanded = true"
      >
        <template #icon>
          <icon-arrow-down />
        </template>
      </btn>
    </div>

    <component
      :is="text.includes('<p') ? 'div' : 'p'"
      class="expanding-content__text"
      v-html="text"
    />
  </div>
</template>

<script>
/**
 * Vue: Expanding content (expanding-content)
 * -----------------------------------------------------------------------------
 * Truncates text over a certain character limit. Allows it to be expanded with
 * a button.
 *
 */

import Btn from '~global/btn/btn'
import IconArrowDown from '~icons/directional-navigation/arrow/down.svg'

export default {
  name: 'ExpandingContent',

  components: {
    Btn,
    IconArrowDown,
  },

  props: {
    characterLimit: {
      type: Number,
      default: 250,
    },
    text: {
      type: String,
      default: '',
    },
    namespace: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      cnvsGlobal: true,
      isExpanded: false,
    }
  },

  computed: {
    /**
     * Compute if content can be expanded
     */
    expandable() {
      return this.textContent.length > this.characterLimit
    },

    /**
     * Compute text content without rich text elements
     */
    textContent() {
      const div = document.createElement('div')
      div.innerHTML = this.text
      return div.textContent
    },
  },

  created() {
    if (!this.expandable) {
      this.isExpanded = true
    }
  },
}
</script>

<style lang="scss">
@import './expanding-content';
</style>
